






















































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { BTable, BvTableCtxObject } from 'bootstrap-vue';
import { eventOff, eventOn } from 'vue-context/src/js/utils';
import { Usuario } from '@/plugins/api';
import { columns } from './components/tabela';
import IndicadorContext from './components/ContextMenu.vue';
import { columnsFilter } from './components/tabela';
import Indicador from "../../../plugins/api/Indicador";

@Component({
  components: {
    IndicadorContext,
  },
})
export default class IndicadoresIndex extends Vue {
  @Ref() readonly table!: BTable;
  @Ref() readonly context!: IndicadorContext;

  public loading = false;

  public currentPage = 1;
  public totalRows = 1;
  public perPage = 50;
  public columns = columns;

  created(): void {
    this.$store.commit('SET_TABELA', 'Faturas');
    this.$store.commit('SET_COLUNAS', columnsFilter);
  }

  mounted(): void {
    eventOn(this.table.$el, 'scroll', this.context.menu.close);
    this.$root.$on('filtros', this.refresh);
  }

  destroy(): void {
    eventOff(this.table.$el, 'scroll', this.context.menu.close);
    this.$root.$off('filtros', this.refresh);
  }

  get filtros(): IFiltroValues[] {
    return this.$store.getters.filtrosSelecionados;
  }

  provider(
    context: BvTableCtxObject,
    callback: (data: IIndicador[]) => void
  ): void {
    this.loading = true;
    const request = {
      params: {
        page: context.currentPage,
        size: context.perPage,
        sortBy: context.sortBy,
        sortDesc: context.sortDesc ? 'DESC' : 'ASC',
        filters: this.filtros,
      },
    };

    Indicador.get(request)
      .then((response: GetIndicadoresResponse) => {
        const indicadores = response.data;
        indicadores.forEach((comissao) => {
          if (comissao.saques.pendentes >= 1) {
            comissao._rowVariant = 'warning';
          }
        });
        callback(indicadores);
        this.totalRows = response.metadata.total;
      })
      .catch(() => {
        callback([]);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public refresh(): void {
    this.table.refresh();
  }

  public clearSelection(): void {
    this.table.clearSelected();
  }

  public contextMenu(item: IIndicador, data: number, event: MouseEvent): void {
    event.preventDefault();
    this.table.selectRow(data);
    this.context.open(event, item);
  }
}
